<template>

    <div class="toggle">
        <a href="#" :class="{ active: view === 'list' }" @click="$emit('input', 'list')">
            <i class="fas fa-list-ul"></i>
        </a>
        <div class="divider"></div>
        <a href="#" :class="{ active: view === 'map' }" @click="$emit('input', 'map')">
            <i class="fas fa-globe"></i>
        </a>
    </div>

</template>

<style scoped lang="scss">

    @import "@sass/_variables.scss";

    .toggle {
        display: flex;
        .divider {
            background: $color-primary;
            height: 40px;
            width: 1px;
        }
        a {
            color: $color-text;
            display: grid;
            font-size: 16px;
            height: 40px;
            overflow: hidden;
            place-items: center;
            text-decoration: none;
            transition: background-color .3s, border-color .3s;
            width: 40px;
            &:hover {
                &:not(.active) {
                    border-color: $color-text;
                }
            }
            &:first-child {
                border: 1px solid $color-rule;
                border-radius: 3px 0 0 3px;
                border-right: none;
            }
            &:last-child {
                border: 1px solid $color-rule;
                border-radius: 0 3px 3px 0;
                border-left: none;
            }
            &.active {
                border-color: $color-primary;
                color: $color-primary;
            }
        }
    }

</style>

<script>

export default {

    props: {
        view: {
            type: String,
            default: 'list',
        },
    },

}

</script>